module.exports = __webpack_public_path__ + "static/hero-image-6a1fe0599fa269254834d7e6f6a99d81.svg";